module.exports = __webpack_public_path__ + "static/media/90 - Miel De Montagne - Pourquoi pas.066f217b.mp3";